import React, { useRef } from 'react';
import { Avatar } from 'primereact/avatar';
import { Menu } from 'primereact/menu';
import { Button } from 'primereact/button';
import { useSidebar } from '../../App/Sidebar/SidebarContext';
import { clearAuth } from '../../utils/auth';

function Topbar() {
  const menu = useRef(null);
  const { collapsed, toggleCollapsed, toggleMobile } = useSidebar();

  const items = [
    {
      label: 'Logout',
      icon: 'pi pi-sign-out',
      command: () => {
        clearAuth();
        window.location.href = '/login';
      },
    },
  ];

  return (
    <div className="admin-topbar">
      <div className="admin-topbar-left">
        <Button
          type="button"
          icon="pi pi-bars"
          className="p-button-text p-button-rounded sidebar-mobile-toggle"
          onClick={toggleMobile}
          aria-label="Open menu"
        />
        <Button
          type="button"
          icon={collapsed ? 'pi pi-angle-double-right' : 'pi pi-angle-double-left'}
          className="p-button-text p-button-rounded sidebar-desktop-toggle"
          onClick={toggleCollapsed}
          aria-label={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}
          tooltip={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}
          tooltipOptions={{ position: 'bottom' }}
        />
      </div>
      <Avatar
        icon="pi pi-user"
        style={{ backgroundColor: '#2020A0', color: '#fff', cursor: 'pointer' }}
        onClick={(e) => menu.current && menu.current.toggle(e)}
        shape="circle"
      />
      <Menu model={items} popup ref={menu} />
    </div>
  );
}

export default Topbar;
